<template>
  <v-list-item two-line>
    <v-list-item-avatar>
      <v-icon>mdi-book-open-page-variant</v-icon>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>
        {{ course.name }}
        <small v-if="course.isDraft" class="font-italic font-weight-light text--secondary">Wersja robocza</small>
      </v-list-item-title>
      <v-list-item-subtitle>Wersja {{ course.version.toString().padEnd(3, '.0') }} </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on }">
          <v-btn rounded color="primary" dark :loading="excelLoading" v-on="on" @click="generateReport">
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </template>
        <span>Generuj raport</span>
      </v-tooltip>
    </v-list-item-action>

    <v-list-item-action class="ml-4">
      <CloneCourse :course="course" />
    </v-list-item-action>

    <v-list-item-action v-if="course.isEditable" class="ml-4">
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            color="teal"
            dark
            v-on="on"
            @click="$router.push({ path: `/manage/courses/edit/${course.id}` })"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Edytuj</span>
      </v-tooltip>
    </v-list-item-action>

    <v-list-item-action v-else class="ml-4">
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            color="primary"
            dark
            v-on="on"
            @click="$router.push({ path: `/manage/courses/view/${course.id}` })"
          >
            <v-icon>mdi-eye-outline</v-icon>
          </v-btn>
        </template>
        <span>Podgląd</span>
      </v-tooltip>
    </v-list-item-action>

    <v-list-item-action>
      <DeleteCourseModal :course="course" />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import ReportApi from '@/api/reportApi';
import { createNamespacedHelpers } from 'vuex';
import CloneCourse from '@/components/manage/courses/right-panel/course-edit/CloneCourse.vue';
import DeleteCourseModal from '@/components/manage/courses/right-panel/course-edit/DeleteCourseModal.vue';

const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  components: {
    CloneCourse,
    DeleteCourseModal
  },
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      excelLoading: false
    };
  },
  computed: mapAccountState(['token']),
  methods: {
    async generateReport() {
      this.excelLoading = true;
      try {
        const api = new ReportApi(this.token);
        const response = await api.getCourseResultReport({
          courseIds: [this.course.id]
        });
        api.downloadFile(response, 'raport.xlsx');
      } catch (e) {
        console.error(e);
        // TODO: handle
      } finally {
        this.excelLoading = false;
      }
    }
  }
};
</script>
